import { S } from "#resources/lib"
import { inputDate } from "#resources/lib/schema"

export class BogusEvent extends S.Opaque<BogusEvent, BogusEvent.Encoded>()(
  S
    .TaggedStruct("BogusEvent", {
      id: S.StringId.withConstructorDefault,
      at: inputDate.withConstructorDefault
    })
    .annotate({ identifier: "BogusEvent" })
) {}

export const ClientEvents = S.Union([BogusEvent])
export type ClientEvents = typeof ClientEvents.Type

// codegen:start {preset: model}
//
export namespace BogusEvent {
  export interface Encoded extends S.StructNestedEncoded<typeof BogusEvent> {}
}
//
// codegen:end
//
